import React, { useRef, useEffect } from "react";
import SlidePreview from "../components/SlidePreview";
import { createSlide, deleteSlide } from "../services/slideService";


export default function SlideViewer({
  slides = [],
  activeSlideId,
  onSelectSlide,
  onSlidesChange,
  deckId,
  ownerId,
}) {
  const slidesListRef = useRef(null);

  useEffect(() => {
    if (activeSlideId && slidesListRef.current) {
      const activeSlideElement = slidesListRef.current.querySelector(
        `[data-slide-id="${activeSlideId}"]`
      );
      if (activeSlideElement) {
        activeSlideElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, [activeSlideId, slides]);

  async function handleCreateSlide() {
    const maxOrder =
      slides.length > 0
        ? Math.max(...slides.map((s) => s.order))
        : 0;

    const newSlide = await createSlide({
      deckId,
      ownerId,
      order: maxOrder + 1000,
    });

    const updatedSlides = [...slides, newSlide].sort(
      (a, b) => a.order - b.order
    );

    onSlidesChange(updatedSlides);
    onSelectSlide(newSlide.id);
  }


  async function handleDeleteSlide(slideId) {
    await deleteSlide(slideId);

    const remaining = slides.filter((s) => s.id !== slideId);
    onSlidesChange(remaining);

    if (slideId === activeSlideId) {
      if (remaining.length > 0) {
        onSelectSlide(remaining[0].id);
      } else {
        onSelectSlide(null);
      }
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.list} ref={slidesListRef}>

        {slides.map((slide, index) => (
          <div key={slide.id} style={styles.item} data-slide-id={slide.id}>
            <div
              onClick={() => onSelectSlide(slide.id)}
              // Added tabIndex="0" to make it programmatically focusable,
              // and ensured no default border on focus.
              tabIndex="0"
              style={styles.clickablePreviewWrapper}
            >
              <SlidePreview
                index={index + 1}
                isActive={slide.id === activeSlideId}
              />
            </div>
           {
            
           }
            <button
              style={styles.deleteBtn}
              onClick={() => handleDeleteSlide(slide.id)}
              tabIndex="-1" // Prevent this button from being tab-focused directly
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <div style={styles.footer}>
        <button style={styles.addBtn} onClick={handleCreateSlide}>
          + Add Slide
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: 120,
    height: "calc(100vh - 56px)",
    borderRight: "1px solid #eee",
    background: "#fafafa",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
  },
  footer: {
    padding: "8px",
    borderTop: "1px solid #eee",
    flexShrink: 0,
  },
  addBtn: {
    border: "none",
    outline: "none",
    background: "#3B00FF",
    color: "#fff",
    borderRadius: 4,
    width: '100%',
    height: 30,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    // Using important for aggressive override, consider external CSS for better practice
    // This removes most default browser button styles that might cause unexpected borders
    border: '2px solid transparent !important', // Explicitly transparent border
  },
  list: {
    flex: 1,
    overflowY: "auto",
    padding: 8,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  item: {
    position: "relative",
  },
  clickablePreviewWrapper: {
    outline: "none",
    border: "2px solid transparent", // <--- Explicitly make border transparent on focus
    cursor: "pointer",
    display: "block",
    // Using important for aggressive override, consider external CSS for better practice
    // This aims to prevent any browser default :focus styles from applying a border.
    borderColor: 'transparent !important',
    boxShadow: 'none !important',
  },
  deleteBtn: {
    position: "absolute",
    top: -6,
    right: -6,
    border: "none",
    outline: "none",
    background: "#ff4d4f",
    color: "#fff",
    borderRadius: "50%",
    width: 18,
    height: 18,
    fontSize: 12,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1,
    border: '2px solid transparent !important', // Explicitly transparent border
  },
};
